<template>
    <div>
        <h5 class="header-text">Complication (複選)</h5>
        <template v-for="(n, index) in items.length">
            <v-layout v-if="(index%2)==0" :key="`complication-${n}`">
                <v-checkbox class="flex xs6 pl-0"
                    :key="items[index].value"
                    :label="items[index].text"
                    :value="items[index].value"
                    v-model="selected"
                    hide-details
                    @change="selectOne(items[index].value)"
                ></v-checkbox>
                <v-checkbox class="flex xs6 pl-0" v-if="items[index+1]"
                    :key="items[index+1].value"
                    :label="items[index+1].text"
                    :value="items[index+1].value"
                    v-model="selected"
                    hide-details
                    @change="selectOne(items[index+1].value)"
                ></v-checkbox>
            </v-layout>
        </template>
        <v-layout 
            class="others full-width">
            <v-checkbox class="pl-0"
                label="其他"
                v-model="othersSelected"
                hide-details
            ></v-checkbox>
            <v-text-field 
                :value="data.complicationOther"
                @change="selectOther($event)"
                hide-details
            ></v-text-field>
        </v-layout>
    </div>
</template>

<script>

export default {
    name: 'ComplicationInput',

    props: {
        data: {
            type: Object,
            required: true
        }
    },

    data () {
        return {
            selected: this.data.complicationIDs,
            othersSelected: false
        }
    },
    computed: {
        items () {
            return this.$store.getters['examinations/getComplicationList']
        }
    },
    methods: {
        selectOne(value, event) {
            this.$emit('change', { field: 'complication', event: this.selected.join(",") })
        },
        selectOther(value) {
            this.$emit('change', { field: 'complicationOther', event: value })
            this.othersSelected = (value && value.length > 0)
        }
    },
    mounted() {
        this.othersSelected = (this.data.complicationOther && this.data.complicationOther.length > 0)
    }
}
</script>